<script setup lang="ts">
const items = [
  {
    title: 'Repeat Order Naik Hingga 3x Lipat',
    icon: 'material-symbols:trending-up'
  },
  {
    title: 'Hemat 10 Jam Kerja/Minggu',
    icon: 'material-symbols:timelapse-outline'
  },
  {
    title: '100% Chat Pelanggan Terjawab Tepat Waktu',
    icon: 'material-symbols:fact-check-outline'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Penjualan Naik, Waktu Hemat, Pelanggan Semakin Loyal!"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="33px"
          :title="item.title"
        />
      </div>
    </UiContainer>
  </section>
</template>
